import { currentResultsCountAtom } from '@components/reviews/shared-atoms';
import { useAppSelector } from '@redux/hooks';
import { useAtomValue } from 'jotai';
import { useMemo } from 'react';

export const useSecondaryCTAIndex = () => {
	const totalReviewsCount = useAtomValue(currentResultsCountAtom);
	const vendorId = useAppSelector((state) => state.vendor.vendor?.id as string);

	return useMemo(() => {
		if (totalReviewsCount <= 0) {
			return -1;
		}

		if (totalReviewsCount < 3) {
			return totalReviewsCount - 1;
		}

		return 2;
	}, [totalReviewsCount, vendorId]);
};
